import React, { FC, useState, useEffect, useMemo } from "react";
import { useWalletConnector } from "../wallet-connector";
import { Web3ButtonProps } from "./Web3ButtonInterface";
import { useWeb3Button } from "./Web3ButtonStore";

export const Web3Button: FC<Web3ButtonProps> = ({
  title,
  prefix,
  disable,
  Web3ButtonView,
  preActionResponse,
  Web3ButtonViewProps,
  preAction = () => {},
  postAction = () => {},
}) => {
  const [counter, setCounter] = useState<number>(0);

  const { web3Sdk } = useWalletConnector();
  const {
    initiatingRequest,
    processingRequest,
    requestSuccessful,
    requestFailed,
    transactionId,
  } = useWeb3Button();

  // useEffect(() => {
  //   if (counter && transactionId) {
  //     checkBlockForTransaction();
  //   }
  //   // eslint-disable-next-line
  // }, [counter, transactionId]);

  useEffect(() => {
    if (preActionResponse && preActionResponse.data) {
      initiatingRequest(title === "SWAPPING" ? "Swap" : title);
      sendTransactionAsync(preActionResponse);
    }
  }, [preActionResponse]);

  const sendTransactionAsync = async (
    transaction: any,
    payload?: any
  ): Promise<string> => {
    const txIds: string[] = [];
    const txId = await new Promise<{ [k: string]: string }>((resolve, reject) =>
      web3Sdk?.eth
        .sendTransaction({
          from: transaction.from,
          to: transaction.contract,
          value: transaction.value || "0x",
          data: transaction.data,
          gas: transaction.gas?.gasLimit,
        })
        .on("transactionHash", (transactionHash) => {
          processingRequest(transactionHash);
          console.log({ transactionHash });
        })
        .on("receipt", (receipt) => {
          if (receipt.transactionHash) {
            console.log({ receipt });
            requestSuccessful();
            postAction(receipt.transactionHash);
          }
        })
        .on("confirmation", (part1, part2) => {
          console.log("confirmation", part1, part2);
        })
        .on("error", (error) => {
          console.log({ error });
        })
        .then((h: any) => {
          resolve(h);
        })
        .catch((err) => {
          console.log({ err });
          reject(err);
          requestFailed();
        })
    );
    txIds.push(txId.transactionHash);
    return txIds.join(",") + "|" + JSON.stringify(payload || "");
  };

  // const delay = (ms: any) => {
  //   new Promise((res) => {
  //     setTimeout(res, ms);
  //   });
  // };

  // const checkBlockForTransaction = async () => {
  //   if (transactionId) {
  //     try {
  //       const transaction = await web3Sdk?.eth.getTransaction(transactionId);
  //       if (transaction && transaction.blockNumber) {
  //         requestSuccessful();
  //         console.log({ transaction });
  //         console.log("transaction successfull");
  //       } else {
  //         console.log("counter", counter);
  //         delay(3000);
  //         if (counter === undefined) {
  //           setCounter(1);
  //         } else {
  //           setCounter(counter + 1);
  //         }
  //       }
  //     } catch (ex) {
  //       setCounter(0);
  //       requestFailed();
  //     }
  //   }
  // };

  return (
    <>
      <Web3ButtonView
        title={title}
        prefix={prefix}
        disabled={disable}
        {...Web3ButtonViewProps}
        onClick={() => preAction()}
      />
    </>
  );
};
